class SiteHeaderComponent extends HTMLElement {
  constructor () {
    super()
    this.init()
    this.eventListenersSet = false
  }

  init () {
    this.setSelectors()
  }

  setSelectors () {
    this.selectors = {
      account: '[data-header-account]',
      cart: '[data-header-cart]',
      logo: '[data-header-logo]',
      menu: '[data-header-menu]',
      navigation: '[data-header-navigation]',
      search: '[data-header-search]',
      title: '[data-header-title]',
      wishlist: '[data-header-wishlist]',
      cartCount: '[data-header-cart-count]',
      mobileMenu: '[data-header-mobile-menu]',
      searchMobile: '[data-header-search-mobile]',
    }
  }

  handleMenuToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'menu-drawer',
      ignoreDismissed: true,
      namespace: 'menuDrawer',
    })
  }

  handleCartToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'cart-drawer',
      ignoreDismissed: true,
      namespace: 'cartDrawer',
    })
  }

  handleWishlistToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'wishlist-list',
      ignoreDismissed: true,
      namespace: 'wishlistDrawer',
    })
  }

  handleSearchToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'search-drawer',
      ignoreDismissed: true,
      namespace: 'searchDrawer',
    })
  }

  setEventListeners () {
    return new Promise(resolve => {
      if (this.eventListenersSet) {
        return
      }
      this.mobileMenu.removeEventListener('click', this.handleMenuToggle)
      this.mobileMenu.addEventListener('click', this.handleMenuToggle)

      this.elements.cart.removeEventListener('click', this.handleCartToggle)
      this.elements.cart.addEventListener('click', this.handleCartToggle)

      this.elements.wishlist.removeEventListener('click', this.handleWishlistToggle)
      this.elements.wishlist.addEventListener('click', this.handleWishlistToggle)

      this.elements.search.removeEventListener('click', this.handleSearchToggle)
      this.elements.search.addEventListener('click', this.handleSearchToggle)

      this.elements.searchMobile.removeEventListener('click', this.handleSearchToggle)
      this.elements.searchMobile.addEventListener('click', this.handleSearchToggle)

      cnvs.EventBus?.listen('cart:update', () => {
        fetch(cnvs.routes.cart.js)
          .then(response => response.json())
          .then(data => {
            if (data.item_count > 0) {
              this.elements.cartCount.innerHTML = data.item_count
            } else {
              this.elements.cartCount.innerHTML = ''
            }
          })
      })

      resolve()
    })
  }

  connectedCallback () {
    // Wait for DOM to be ready
    requestAnimationFrame(() => {
      // Get DOM elements using selectors
      this.elements = {}
      for (const [key, selector] of Object.entries(this.selectors)) {
        this.elements[key] = document.querySelector(selector)
      }
      this.setEventListeners().then(() => {
        this.eventListenersSet = true
      })
    })
  }

  get mobileMenu () {
    return this.elements.mobileMenu
  }
}

if (!customElements.get('site-header-component')) {
  customElements.define('site-header-component', SiteHeaderComponent)
}

class PreHeaderBanner extends HTMLElement {
  constructor () {
    super()
    this.eventListenersSet = false
  }

  connectedCallback () {
    requestAnimationFrame(() => {
      this.setupListeners()
    })
  }

  setupListeners () {
    return new Promise(resolve => {
      if (this.eventListenersSet) {
        return
      }
      const nodes = this.querySelectorAll('[data-pre-header-banner-el="message"]')
      document.body.classList.add('pre-header-banner--visible')

      const total = nodes.length
      const { interval = 3000 } = this.dataset

      if (total > 1) {
        let index = 0

        window.setInterval(() => {
          nodes[index].classList.remove('pre-HeaderBanner_Message-visible')
          index = (index + 1) % nodes.length
          nodes[index].classList.add('pre-HeaderBanner_Message-visible')
        }, Number(interval))
      } else {
        nodes[0]?.classList.add('pre-HeaderBanner_Message-visible')
      }

      const close = this.querySelector('[data-pre-header-banner-el="close"]')

      if (close) {
        close.addEventListener('click', () => {
          document.body.classList.remove('pre-header-banner--visible')
          document.body.classList.add('pre-header-banner--dismissed')
          this.setCartAttribute()
        })
      }
      resolve()
    })
  }

  async setCartAttribute () {
    const { attributeKey } = this.dataset

    if (!attributeKey) return

    const res = await fetch('/cart.js')
    const { attributes } = await res.json()

    const newAttributes = {
      ...attributes,
      [attributeKey]: true,
    }

    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: newAttributes }),
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

if (!customElements.get('pre-header-banner')) {
  customElements.define('pre-header-banner', PreHeaderBanner)
}
